(function() {
    'use strict';
  
    angular
        .module('iqxCore')
        .service('inactivitySvc', inactivitySvc)
  
    function inactivitySvc(ApplicationSvc, SweetAlert, $location, $interval, $timeout){
        var svc = this
        svc.activate=activate
        svc.enable = enable
        svc.disable = disable
        svc.callBack = svc.callBack || (function(){})


        var warningMessageShowing,
            warningTime,
            logoffTime,
            lastActivity,
            checker

        activate()

        ///////////

        function activate(){
            warningMessageShowing = false
            lastActivity = null
            document.onmousedown = activityDetected
            document.ontouchstart = activityDetected
            document.onkeydown = activityDetected
        }

        function enable(){
            if (ApplicationSvc.isApp === true || ApplicationSvc.isWebView === true){return} // we dont want inactivity if we're using the app.

            if(!ApplicationSvc.params.INACTIVITYTIMER || ApplicationSvc.params.INACTIVITYTIMER === 0){
                lastActivity = null
                return
            }
            if(lastActivity!==null || $location.path() == '/pin'){ // already enabled
                return
            }
            warningTime = ApplicationSvc.params.INACTIVITYTIMER-1
            logoffTime = ApplicationSvc.params.INACTIVITYTIMER
            lastActivity = moment()
            checker = $interval(function(){
                checkTimer()
            }, 10000) // check the timer every 10 seconds
        }

        function disable(){
            if(lastActivity===null){ // aleardy disabled
                return
            }
            $interval.cancel(checker)
            lastActivity = null
        }

        function activityDetected(){
            checkTimer(true)
        }

        function checkTimer(activityDetected, resetWarning){
            if(lastActivity===null){ // lastActivity is null when inactivity timer is disabled.
                return
            }

            if(moment().isAfter(lastActivity.clone().add(logoffTime, "minutes"))){
                timeRanOut()
            }else if(moment().isAfter(lastActivity.clone().add(warningTime, "minutes")) && !warningMessageShowing && !resetWarning){
                warn()
            }else if(activityDetected && !warningMessageShowing){
                lastActivity = moment()
            }
        }

        function warn(){
            var title = "You are about to be logged out!"
            var text = "You will be logged out in less than one minute due to inactivity, any unsaved work will be lost."
            if(ApplicationSvc.currentUser.pinauth===true){
                title = "Your session is about to be locked"
                text = "Your session will be locked in a less than one minute due to inactivity, any unsaved work will be lost and you will be required to enter your PIN to resume your session."
            }
            warningMessageShowing = true
            SweetAlert.swal({
                title: title,
                text: text,
                type: "warning",
                confirmButtonText: "Stay logged in",
                allowOutsideClick:false,
                allowEscapeKey:false
            }).then(function(){ // not passing result as we dont need it, there is only one btn to press
                warningMessageShowing = false
                checkTimer(true, true)
            })
            
        }

        function timeRanOut(){
            SweetAlert.swal.close()
            warningMessageShowing = false
            svc.callBack()
            $timeout(function(){
                $location.path("/login")
            }, 100)
            
        }

    }
  
})()
  